import { Store } from '@reduxjs/toolkit';
import { ProjectRenderer } from '@/renderer/ProjectRenderer';
import { ThreeEvent } from '@/renderer/types';
import { creatorActions } from './slices/creatorSlice';

const renderer = ProjectRenderer.getInstance();

export function initCreatorListeners(store: Store) {
	for (const event of Object.values(ThreeEvent)) {
		renderer.emitter.on(event, (data) => {
			store.dispatch(
				creatorActions.handleRendererEvent({
					type: event,
					data,
				})
			);
		});
	}
}
